<template>
  <Sidebar>
    <AttachmentList :items="attachments">
      <template slot="top">
        <BackListItem :title="$t('Back_to_agenda_item')" :parent="agendaitem" :subtitle="agendaitem.title" />
        <v-divider />
        <template v-if="proposal">
          <v-subheader>{{ $t('agenda_item_proposal') }}</v-subheader>
          <LinkedListItem :item="proposal" data-testid="proposal-list-item">
            <v-list-item-avatar class="rounded-0">
              <v-icon>{{ `${proposal.mimeTypeIcon}` }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ $t('agenda_item_proposal_document') }}</v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ $t('last_update_on', { date: toLocaleDateTimeString(proposal.updated) }) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <TagList :tags="proposal.tags" />
              </v-list-item-subtitle>
            </v-list-item-content>
            <ListActionIndicator :item="proposal" />
          </LinkedListItem>
          <v-divider />
          <v-subheader>{{ $t('Attachments') }}</v-subheader>
        </template>
        <v-subheader v-else>{{ $t('Documents') }}</v-subheader>
      </template>
    </AttachmentList>
  </Sidebar>
</template>

<script>
import Attachment from '@/store/models/attachment'
import AttachmentListItem from '@/components/listitems/AttachmentListItem'
import mixin from '@/components/sidebars/mixin'
import { toLocaleDateTimeString } from '@/filters'

export default {
  name: 'ProposalSidebar',
  mixins: [mixin],
  props: {
    proposal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      AttachmentListItem,
    }
  },
  computed: {
    attachments() {
      return Attachment.query().where('agenda_item_id', this.proposal.agenda_item.id).all()
    },
    agendaitem() {
      return this.proposal.agenda_item
    },
  },
  methods: {
    toLocaleDateTimeString,
  },
}
</script>
